import React, { ReactElement } from 'react';
import { PersonBaseInterface } from 'components/interfaces/PersonInterface';
import { getTranslation, useTranslation } from 'utils/localization';
import PersonBase from 'components/pages/person/detail/base/PersonBase';
import { ConfigPageInterface } from 'utils/helpers/server/serverSideProps/config';
import {
    CoachClubListItemApiInterface,
    CoachDetailApiInterface,
} from 'submodules/api_middleware';
import { Config_CoachDetail_ApiInterface } from 'submodules/api_middleware/src/interfaces/config/CoachDetailConfigApiInterface';
import getCoachOverview from 'components/pages/person/detail/base/utils/getCoachOverview';
import CoachLicencesBlock from 'components/pages/coach/detail/CoachLicencesBlock';
import CoachCareerBlock from 'components/pages/coach/detail/CoachCareerBlock';
import { TNamespaceEnum } from 'types/types';

interface Props extends ConfigPageInterface<Config_CoachDetail_ApiInterface> {
    personBase: PersonBaseInterface;
    coach: CoachDetailApiInterface;
    clubs: CoachClubListItemApiInterface[];
}

const CoachPage = ({
    personBase,
    coach,
    clubs,
    config,
}: Props): ReactElement => {
    const { t } = useTranslation();
    return (
        <PersonBase
            config={config}
            personBase={personBase}
            pageSubTitle={getTranslation(
                t,
                TNamespaceEnum.person,
                'role.coach'
            )}
            minimizeGradient
            isArchived={!!coach.archived_at}
            overview={getCoachOverview({ t, coach })}
        >
            <>
                <CoachLicencesBlock
                    entries={coach.licences}
                    title={t('CoachPage.licencesOverview')}
                />
                <CoachCareerBlock
                    entries={clubs}
                    title={t('CoachPage.career')}
                    coachId={coach.publish_id}
                />
            </>
        </PersonBase>
    );
};

export default CoachPage;
